<template>
    <div class="container" data-contract-company="tflain" data-html-name="송금 요청(동의서)서">
        <!-- contract : 계약서 / manual : 설명서 -->
        <div class="contract">

            <header-blue>
                <template #backBtn>
                    <!-- class : show로 처리 -->
                    <button class="backBtn_icon"></button>
                </template>
                <div slot="title">송금 요청(동의서)서</div>
            </header-blue>

            <main class="bottom_btn_case">

                <section class="default">

                    <article class="user_info_article">
                        <div class="title_wrap">
                            <div class="section_title">채권자</div>
                        </div>
                        <div class="common_box">
                            <div class="user_info_title">성명</div>
                            <div>{{  }}</div>
                        </div>
                        <div class="common_box">
                            <div class="user_info_title">주소</div>
                            <div>{{  }}</div>
                        </div>
                        <div class="common_box">
                            <div class="user_info_title">연락처</div>
                            <div>{{ "01012341234" | formatPhoneNr }}</div>
                        </div>
                    </article>

                    <article class="user_info_article">
                        <div class="title_wrap">
                            <div class="section_title">채무자</div>
                        </div>
                        <div class="common_box">
                            <div class="user_info_title">성명</div>
                            <div>{{  }}</div>
                        </div>
                        <div class="common_box">
                            <div class="user_info_title">주소</div>
                            <div>{{  }}</div>
                        </div>
                        <div class="common_box">
                            <div class="user_info_title">연락처</div>
                            <div>{{ "01012341234" | formatPhoneNr }}</div>
                        </div>
                    </article>

                    <article class="signature_article">
                        <div data-sign="sign_field">
                            <div class="label_case">채무자</div>
                            <SignatureInput>
                                <template #signature>
                                    <input
                                        ref="inputField"
                                        type="text"
                                        id="sign"
                                        class="sign"
                                        v-model="contractDetail.kornNm"
                                        :class="{ blue: signatureColor }"
                                        disabled
                                    >
                                    <label for="sign" @click="openSignDebtor()">
                                        <button v-html="signedData"></button>
                                    </label>
                                </template>
                            </SignatureInput>
                        </div>
                    </article>

                    <article>
                        <div class="area_block">
                            채권자와 채무자는 아래와 같이 금전소비대차 계약을 체결한 바 있음
                        </div>
                    </article>

                    <article>
                        <div class="area_block next">- 아래 -</div>
                    </article>


                    <article class="user_info_article">
                        <table class="terms_table">
                            <tbody>
                                <tr>
                                    <th>계약일</th>
                                    <td>
                                        {{ }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>대출원금</th>
                                    <td>
                                        {{ }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>정상이율</th>
                                    <td>
                                        {{ }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>연체이율</th>
                                    <td>
                                        {{ }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>계약만료일</th>
                                    <td>
                                        {{ }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </article>

                    <article>
                        <div class="area_block">
                            채권자는 위 대출원금을 채무자 명의 계좌를 입금 해야 하나, 채무자의 요청으로 다음과 같이 송금한다
                        </div>
                    </article>

                    <article class="user_info_article">
                        <table class="terms_table">
                            <tbody>
                                <tr>
                                    <th>송금요청일</th>
                                    <td>
                                        {{ "2024.05.02" }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>예금주</th>
                                    <td>
                                        {{ }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>송금요청액</th>
                                    <td>
                                        {{ }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>사유</th>
                                    <td>
                                        {{ "오토바이 구입(렌탈) 자금 등" }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </article>

                    <article>
                        <div class="label_case">날짜</div>
                        <div class="common_box single_data_case">
                            <div class="single_data">{{ contractDetail.cntrctDt | formatDate }}</div>
                        </div>
                    </article>

                    <article class="signature_article">
                        <div data-sign="sign_field">
                            <div class="label_case">송금요청인</div>
                            <SignatureInput>
                                <template #signature>
                                    <input
                                        ref="inputField"
                                        type="text"
                                        id="sign"
                                        class="sign"
                                        v-model="contractDetail.kornNm"
                                        :class="{ blue: signatureColor }"
                                        disabled
                                    >
                                    <label for="sign" @click="openSignDebtor()">
                                        <button v-html="signedData"></button>
                                    </label>
                                </template>
                            </SignatureInput>
                        </div>
                    </article>

                </section>

                <section class="bottomBtn_wrap">
                    <BottomBtn>
                        <button
                            slot="bottom_btn"
                            class="primary_btn"
                            @click="completeContract()"
                            :class="{ active: isDisabled }"
                        >
                            대출거래 계약하기
                        </button>
                    </BottomBtn>
                </section>

            </main>
        </div>

        <CommonModal v-if="isKornNm" @confirmBtn="confirmKornNmModal()">
            <div slot="ModalContent">
                <span class="emp_red">이름</span>을<br>
                잘못 입력하셨습니다.
            </div>
        </CommonModal>

        <CommonModal v-if="isKornNmSignatureModal" @confirmBtn="checkKornNmSignatureModal()">
            <div slot="ModalContent">
                <span class="emp_red">본인서명</span>을<br>
                해주셔야 합니다.
            </div>
        </CommonModal>

        <SignatureDebtor v-if="showSignatureDebtor" ref="signaturePad" @close="closeSignatureDebtor()"
                         @save="saveSignatureDebtor" :propsName="contractDetail.kornNm" :propsBizCode="contractDetail.bizCode"/>
        <InicisComponent ref="openPopup"/>
    </div>
</template>

<script>
import {mapState, mapGetters,} from 'vuex'
import SignatureDebtor from '@/components/common/SignaturePad.vue'
import InicisComponent from "@/components/InicisComponent.vue";

export default {
    components: {
        SignatureDebtor,
        InicisComponent,
    },
    data() {
        return {
            contractDetail: null,
            showSignatureDebtor: false,
            name: '',
            isKornNm: false,

            // check
            isKornNmSignatureModal: false,
        }
    },
    created() {
        this.contractDetail = this.commonContractStore.contractDetail
    },
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {
        ...mapGetters('TflainIndividualContractStore', ['EC01TF', 'EC02TF', 'EC03TF', 'EC04TF', 'EC05TF', 'EC08TF', 'EC09TF']),
        ...mapState({
            commonContractStore: state => state.TflainCommonContractStore,
            individualContractStore: state => state.TflainIndividualContractStore,
        }),
        // 사인 데이터 관련
        signedData() {
            const data = this.EC09TF.signedData
            if (data.startsWith('data:image')) {
                return `<img width='80' height='38' src='${data}' alt="">`
            } else {
                return data
            }
        },
        returnName() {
            return this.EC09TF.name
        },
        signatureColor() {
            return this.EC09TF.nameColorValid
        },
        // 다음페이지로 넘어가기 위한 조건
        isDisabled() {
            const setPath = this.EC09TF
            return setPath.signedDataValid
        },
        contractSignedData() {
            return {
                signedData01: this.EC01TF.signedData,
                signedData02: this.EC02TF.signedData,
                signedData03: this.EC03TF.signedData,
                signedData04: this.EC04TF.signedData,
                signedData05: this.EC05TF.signedDataAgreementFirst,
                signedData06: this.EC05TF.signedDataAgreementSecond,
                signedData07: this.EC08TF.signedData,
                signedData08: this.EC09TF.signedData,
                PCICollectionCheckbox: this.convertToString(this.EC04TF.PCICollectionCheckbox),
                PCIProvideCheckbox: this.convertToString(this.EC04TF.PCIProvideCheckbox),
                marketingChannelPhoneCheckbox: this.convertToString(this.EC04TF.marketingChannelPhoneCheckbox),
                marketingChannelSNSCheckbox: this.convertToString(this.EC04TF.marketingChannelSNSCheckbox),
                marketingChannelWritingCheckbox: this.convertToString(this.EC04TF.marketingChannelWritingCheckbox),
                marketingChannelEmailCheckbox: this.convertToString(this.EC04TF.marketingChannelEmailCheckbox),
                kakaoAlertingServiceCheckbox: this.convertToString(this.EC04TF.kakaoAlertingServiceCheckbox)
            }
        },
    },
    methods: {
        openSignDebtor() {
            this.showSignatureDebtor = !this.showSignatureDebtor
        },
        closeSignatureDebtor() {
            this.showSignatureDebtor = false
            this.$nextTick(() => {
                window.scrollTo(0, 0);
            })
        },
        saveSignatureDebtor() {
            const result = this.$refs.signaturePad.saveSignature()
            if (result.isEmpty) {
                alert('서명이 비어 있습니다');
            } else {
                this.$store.commit('TflainIndividualContractStore/EC09TF_SIGNATURE_DEBTOR', {
                    data: `${result.data}`,
                    isValid: true
                })
            }
            this.showSignatureDebtor = !this.showSignatureDebtor
        },
        isValidName(e) {
            if (this.contractDetail.kornNm === e.target.value) {
                this.$store.commit('TflainIndividualContractStore/EC09TF_SIGNATURE_NAME', {
                    name: e.target.value,
                    isValid: true
                })
                this.$store.commit('TflainIndividualContractStore/EC09TF_SIGNATURE_COLOR', false)
                this.$refs.inputField.blur();
            }
        },
        isValidKornNm(e) {
            if (this.contractDetail.kornNm !== e.target.value) {
                this.isKornNm = true
            }
        },
        confirmKornNmModal() {
            this.isKornNm = false
        },
        checkKornNmSignatureModal() {
            this.isKornNmSignatureModal = false
            this.showSignatureDebtor = !this.showSignatureDebtor
        },
        async completeContract() {
            if (!this.EC09TF.signedDataValid) {
                this.isKornNmSignatureModal = true
            } else {
                await this.$store.dispatch('inicisStore/FETCH_INICIS', this.commonContractStore.contractDetail.mgNo)
                    .then(async response => {
                        if (response.data.result !== true || response.data.contents.userBirth.length !== 8) {
                            await this.$router.replace({name: 'InicisFailedComponent'});
                        } else {
                            this.$store.commit('TflainIndividualContractStore/SIGNED_DATA', {
                                signedData: this.contractSignedData
                            })
                            await this.$refs.openPopup.openPopup()
                        }
                    });
            }

        },
    }
}
</script>

<style>

</style>